export class AppConfig {
    public baseApiUrl = '';
  }
  